import Page from "webPage/Page";
import Ajax from "base/Ajax";
import { svg_include } from "base/functions";
import PromiseHelper from "base/PromiseHelper";
import queryString from "query-string";
import FormValidator from "base/FormValidator";
import { buildSearchResult } from "uti/results";

Page.register(["/search"], () => {

    let $form = $('.js-search-form');
    let $sort = $('.js-sort');
    let $results = $('.js-results');
    let $sortForm = $('.js-sort-form');
    let $sortInputs = $sortForm.find('.js-sort-inputs');
    let $pagination = $('.js-pagination-holder');
    let $searchSection = $('.js-search-section');
    let currentRequest = null;

    $sort.on('change', function () {
        //Abort any active request
        if (currentRequest !== null) {
            currentRequest.abort();
        }

        //Remove loading button from main form
        $form.find('button[type="submit"]').removeClass('btn--loading');

        //Do search and update page
        update_results($sortForm.serializeJSON());

        //Update the hidden sort input in the main search
        $form.find('input[name="sort"]').val($(this).val());

    });

    FormValidator.attach($form).on('submit', (e) => {
        let $btn = $form.find('button[type="submit"]');

        if ($btn.is('.btn--loading')) return false;

        $btn.addClass('btn--loading');

        let sentData = $.extend(true, {}, $form.serializeJSON(), {
            sort: $sort.val(),
        });

        //Do search and update page
        update_results(sentData);
    });

    $('body').on('click', '.js-pagination-link', function () {

        //Abort any active request
        if (currentRequest !== null) {
            currentRequest.abort();
        }

        //Remove loading button from main form
        $form.find('button[type="submit"]').removeClass('btn--loading');

        let sentData = queryString.parse(this.search, {arrayFormat: "bracket"});
        sentData.depth = 15;

        //Do search and update page
        update_results(sentData);

        return false;
    }).on('click', '.js-result', function () {
        try {
            gtag('event', 'file_downloaded', {
                'event_category': 'Document Download',
                'event_label': $(this).attr('data-title'),
            });
        } catch (e) {
            console.log(e);
        }
    }).on('click', '.js-print-link', function (e) {
        if (e.ctrlKey) return;

        let $link = $(this).clone();
        let link = $link[0];

        link.search += (link.search.length === 0 ? "" : "&") + "print";

        let url = link.href;

        $("body").append(eotwJSXFactory('iframe', {sandbox: "allow-modals allow-scripts allow-same-origin", src: url}).hide());

        return false;
    });

    $(window).on("popstate", (e) => {
        let query = Page.get_query();
        update_results(query, false);

        // Update inputs to match URL

        // Update keywords input
        $form.find(".js-terms").val(query.term ? query.term : "");

        // Update sort input
        $sort.find("option").each((_, option) => option.selected = option.value === query.sort);

        // Update categories inputs
        $form.find(".js-category-option").each((_, checkbox) => {
            checkbox.checked = Array.isArray(query.category) && query.category.indexOf(checkbox.value) !== -1;
        }).last().trigger("change");
    });

    function update_sort_form(sentData) {
        $sortInputs.html('');

        Object.keys(sentData).forEach((index) => {
            if (['sort', 'depth', 'page'].indexOf(index) !== -1) return;
            if (Array.isArray(sentData[index])) {
                sentData[index].forEach((i) => {
                    $sortInputs.append(
                        eotwJSXFactory('input', {type: "hidden", name: index + '[]', value: i, 'data-optional': true}),
                    );
                });
            } else {
                $sortInputs.append(
                    eotwJSXFactory('input', {type: "hidden", name: index, value: sentData[index], 'data-optional': true}),
                );
            }
        });
    }

    function update_url(sentData) {
        delete sentData.depth;

        let url = '/search?' + $.param(sentData).replace(/%5B%5D/g, "[]");

        history.pushState({}, "", url);

        try {
            gtag('config', window.GA_TRACKING_ID, {
                'page_path': window.location.pathname,
                'page_location': window.location.href,
                'page_title': document.title,
            });
        } catch (e) {
            console.log(e);
        }
    }

    function update_results(sentData, pushState = true) {
        //Add Loading to search section
        $searchSection.addClass('search-section--loading');

        currentRequest = Ajax.get('whiteEagleLodge', 'search', $.extend({}, sentData, {depth: 15}), Ajax.WEBSITE);

        let top = $('.js-search-section').offset().top - ($('.header').outerHeight() + parseInt($('body').css('margin-top')));
        $('html, body').animate({scrollTop: top}, 400);

        let text = $('input[name="term"]').val();

        $('.js-search-text').text(text);

        PromiseHelper.delayed_promise(currentRequest, 800).then((data) => {
            //Clear all old results
            $results.html('');

            //Remove loading
            $form.find('button[type="submit"]').removeClass('btn--loading');
            $searchSection.removeClass('search-section--loading');

            //Update text at the top of the page
            update_results_text(sentData, data.totalResults);

            if (pushState) {
                //Push search terms to url
                update_url(sentData);
            }

            if (data.totalResults <= 0) {
                //No results show message
                let categoryText = 'All Documents';
                if (window.CATEGORIES_ACTIVE) {
                    //Set category text if only one category selected or display All Documents
                    categoryText = sentData.category.length > 1 ? 'All Documents' : $('.js-category-option[value="' + sentData.category[0] + '"]').parent().find('.js-category-text').text();
                }

                $results.html(
                    eotwJSXFactory('div', {className: "results-message"}, [
                        eotwJSXFactory('span', {className: "results-message__icon"}).html(svg_include('search-icon')),
                        eotwJSXFactory('h2', null, ["Sorry, we couldn't find \"", eotwJSXFactory('strong', null, [sentData.term]),"\" ", window.CATEGORIES_ACTIVE ? (eotwJSXFactory('span', null, [" in ", eotwJSXFactory('em', null, [categoryText])])) : undefined]),
                        eotwJSXFactory('p', null, ["Please try searching again, and be sure to check your spelling. If your search term is too general or short, please try entering a more specific search phrase."])
                    ]),
                );

                //Hide number of results and sort section and pagination
                $('.js-results-meta, .js-pagination-holder').hide();
            } else {
                //Show number of results and sort section and pagination
                $('.js-results-meta, .js-pagination-holder').show();

                data.documents.forEach((document) => {
                    $results.append(buildSearchResult(document));
                });
            }

            //Update pagination
            update_pagination(sentData, data.totalPages, data.currentPage, data.totalResults);
            update_print_link(sentData);

            $(".js-search-meta").remove();
            if (!data.shouldIndex) {
                $("head").append(eotwJSXFactory('meta', {name: "robots", content: "noindex,nofollow", className: "js-search-meta"}));
            }
            $("head").append(eotwJSXFactory('link', {rel: "canonical", href: window.location.href, className: "js-search-meta"}));

            //Update the sort form to have the latest search data
            update_sort_form(sentData);
        }).catch((e) => {
            //Hide number of results and sort section and pagination
            $('.js-results-meta, .js-pagination-holder').hide();

            //Remove loading
            $form.find('button[type="submit"]').removeClass('btn--loading');
            $searchSection.removeClass('search-section--loading');

            $results.html(
                eotwJSXFactory('div', {className: "results-message"}, [
                    eotwJSXFactory('span', {className: "results-message__icon results-message__icon--error"}).html(svg_include('error-icon')),
                    eotwJSXFactory('h2', null, ["Sorry, we encountered a problem"]),
                    eotwJSXFactory('p', null, ["We couldn’t complete your search request. Please try again later. If this issue persists, please email us at ", eotwJSXFactory('a', {href: "mailto:info@whiteagle.org"}, ["info@whiteagle.org"])," and let us know exactly what you were searching for, along with an approximate time and date."])
                ]),
            );
        });
    }


    function update_print_link(sentData) {
        delete sentData.page;
        delete sentData.depth;

        let base = '/print?' + $.param(sentData).replace(/%5B%5D/g, "[]");

        $('.js-print-link').attr('href', base);
    }

    function update_pagination(sentData, totalPages, currentPage, totalResults) {
        $pagination.html('');

        if (totalPages <= 1) {
            $('.js-pagination-holder').hide();
            return;
        }

        delete sentData.page;
        delete sentData.depth;

        let base = '/search?' + $.param(sentData).replace(/%5B%5D/g, "[]") + '&page=';

        let $ul = eotwJSXFactory('ul', {className: "pagination__list"});
        if (currentPage > 1) {
            $ul.append(
                eotwJSXFactory('li', {class: "pagination__item pagination__item--direction"}, [
                    eotwJSXFactory('a', {href: base + (currentPage - 1), className: "js-pagination-link pagination__link pagination__link--direction pagination__link--direction-left"}, [eotwJSXFactory('span', {className: "pagination__arrow pagination__arrow--flipped"}).html(svg_include('arrow')), "Prev"])
                ]),
            );
        } else {
            $ul.append(eotwJSXFactory('li', {className: "pagination__item pagination__item--placeholder pagination__item--direction"}));
        }

        for (let i = Math.max(1, currentPage - 3); i <= Math.min(totalPages, currentPage + 3); i++) {
            $ul.append(
                eotwJSXFactory('li', {className: "pagination__item"}, [eotwJSXFactory('a', {href: base + i, className: "js-pagination-link pagination__link " + (i === currentPage ? "pagination__link--active" : "")}, [i])]),
            );
        }

        $ul.append(
            eotwJSXFactory('li', {class: "pagination__item pagination__item--mobile-pages"}, [
                eotwJSXFactory('span', {class: "pagination__text"}, ["Page ", currentPage, " of ", totalPages])
            ]),
        );

        if (currentPage < totalPages) {
            $ul.append(
                eotwJSXFactory('li', {className: "pagination__item pagination__item--direction"}, [
                    eotwJSXFactory('a', {href: base + (currentPage + 1), className: "js-pagination-link pagination__link pagination__link--direction"}, ["Next", eotwJSXFactory('span', {className: "pagination__arrow"}).html(svg_include('arrow'))])
                ]),
            );
        } else {
            $ul.append(eotwJSXFactory('li', {className: "pagination__item pagination__item--placeholder pagination__item--direction"}));
        }

        $pagination.append($ul);

        if ('undefined' === typeof sentData.no_limit) {
            $pagination.append(
                eotwJSXFactory('a', {href: base + "1&no_limit", className: "pagination__view-all js-pagination-link"}, [
                    "View ", totalResults > 100 ? "100" : "all " + totalResults, " results"
                ]),
            );
        }
    }

    function update_results_text(data, totalResults) {
        //Update main version for all sizes from tablet and above
        let text = 'Displaying ' + totalResults + ' result' + (totalResults === 1 ? '' : 's') + ' ';

        //Check that a term has been entered
        if ('undefined' !== typeof data.term && data.term.trim().length > 0) {
            text += 'for <strong> ' + data.term + ' </strong>';
        }

        if (window.CATEGORIES_ACTIVE && 'undefined' !== typeof data.category) {
            //Set category text if only one category selected or display All Documents
            let categoryText = data.category.length > 1 ? 'All Documents' : $('.js-category-option[value="' + data.category[0] + '"]').parent().find('.js-category-text').text();

            text += 'within <em>' + categoryText + '</em>';
        }

        $('.js-results-text').html(text);

        //Update number version for mobile and phablet
        $('.js-results-number').html([eotwJSXFactory('span', {class: "results-count__number"}, [totalResults]), ' Result' + (totalResults === 1 ? '' : 's')]);
    }
});
